<template>
    <div class="pagination">
        <router-link v-if="page>min_page" :to="{ name: route_name , params:{page:(page-1)} , query:$route.query }"> &larr; </router-link>
        |
        <span v-for="index in (min_page , max_page)" :key="index">
            <router-link v-if="page!==index" :to="{ name: route_name , params:{page:index} , query:$route.query }">{{index}}</router-link>
            <span v-if="page===index">{{index}}</span>
            |
        </span>
        <router-link v-if="page<max_page" :to="{ name: route_name , params:{page:(page+1)} , query:$route.query }"> &rarr; </router-link>
    </div>
</template>

<script>
    export default {
        name: 'Footer',
        components: {
        },
        data:function(){
            return {
                min_page:1,
                max_page:1,
            }
        },
        methods:{
        },
        props:[
            'options',
            'route_name',
            'page',
            'on_page',
            'total_item',
        ],
        mounted() {
            this.max_page = Math.ceil(this.total_item / this.on_page);
        },
        watch:{
            'total_item': function() {
                this.max_page = Math.ceil(this.total_item / this.on_page);
            },
            'on_page': function() {
                this.max_page = Math.ceil(this.total_item / this.on_page);
            },
        },
    }
</script>


<style scoped>
</style>
